import { render, staticRenderFns } from "./materialInfoCell.vue?vue&type=template&id=e4d58b9c&scoped=true"
import script from "./materialInfoCell.vue?vue&type=script&lang=js"
export * from "./materialInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d58b9c",
  null
  
)

export default component.exports